import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { UserLoginService } from 'src/app/shared/services/user-login.service';
import { LoaderService } from 'src/app/shared/utils/loader.service';

import { MFValidators } from 'src/app/shared/validators/mf-validators';
import { AccountSettingsService } from '../account-setting.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-account-password-change',
  templateUrl: './account-password-change.component.html',
  styleUrls: ['./account-password-change.component.scss'],
})
export class AccountPasswordChangeComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Input() SuccessMessage!: string;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() SuccessMessageChange = new EventEmitter<string>();
  hideOld: boolean = true;
  hideNew: boolean = true;
  hideConfirm: boolean = true;
  submited = false;
  readonly LANG_CONST = LANG_CONST;
  newPasswordForm!: FormGroup;
  errorMessage: string = '';

  get formInstance() {
    return this.newPasswordForm?.controls;
  }

  constructor(
    private fb: FormBuilder,
    private accountSettingService: AccountSettingsService,
    private notificationService: NotificationService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.localizationService.setupLocalization();
    this.newPasswordForm = this.fb.group(
      {
        newPassword: [
          '',
          [
            MFValidators.required,
            MFValidators.minLength(8),
            MFValidators.maxLength(20),
            MFValidators.setPassword,
          ],
        ],
        confirmPassword: [
          '',
          [
            MFValidators.required,
            MFValidators.minLength(8),
            MFValidators.maxLength(20),
            MFValidators.password,
          ],
        ],
        oldPassword: ['', [MFValidators.required]],
      },
      {
        validator: MFValidators.matchPassword('newPassword', 'confirmPassword'),
      }
    );
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }

  /**
   * @description ##updatePassword function trigger on update button and call the changePassword API.
   * @returns void
   */
  updatePassword() {
    if (
      this.formInstance.newPassword.value ===
      this.formInstance.oldPassword.value
    ) {
      this.notificationService.showError(
        this.translate.instant('OLD_NEW_PASSWORD_CANNOT_BE_SAME')
      );
    } else {
      this.accountSettingService
        .changePassword(
          this?.formInstance.oldPassword.value,
          this?.formInstance.newPassword.value
        )
        .subscribe({
          next: (res: any) => {
            if (res?.changePassword?.success) {
              this.SuccessMessageChange.emit(
                (this.SuccessMessage =
                  this.translate.instant('PASSWORD_UPDATED'))
              );
              this.stepperChange.emit((this.stepper = 5));
              this.notificationService.showSuccess(
                this.translate.instant('SUCCESSFULLY_UPDATED')
              );
            }
          },
          error: (err: Error) => {
            this.errorMessage = err.message;
            this.notificationService.showError(err?.message);
          },
        });
    }
  }
}
